import { render, staticRenderFns } from "./NormalButton.vue?vue&type=template&id=18ebdf4e&scoped=true&"
import script from "./NormalButton.vue?vue&type=script&lang=js&"
export * from "./NormalButton.vue?vue&type=script&lang=js&"
import style0 from "./NormalButton.vue?vue&type=style&index=0&id=18ebdf4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ebdf4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
